<template>
  <div class="tab-pane fade show active" role="tabpanel">
    <div class="card border-translucent">
      <div class="card-body">
        <InventoryManagementComponent
          v-if="companiesWithIds.length > 0 && companiesWithIds[0].id"
          :key="selectedCompanyIds.join(',')"
          :company-id="companiesWithIds[0].id"
          :company="companiesWithIds[0]"
          :companies="companiesWithIds"
          :is_admin="isAdmin"
          :account="accountData"
        />
        <LoadingIndicatorComponent v-else />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import LoadingIndicatorComponent from "@/components/common/LoadingIndicatorComponent.vue";
import InventoryManagementComponent from "@/dashboard/inventory_management/InventoryManagementComponent.vue";
import type { Account, Company } from "@/types";

defineProps<{
  selectedCompanyIds: number[];
  companiesWithIds: Array<Company & { id: number }>;
  isAdmin: boolean;
  accountData: Account;
}>();
</script>
